import { type TamaguiElement, YStack } from 'tamagui';
import { forwardRef } from 'react';
import Text from '../../Text/Text';

type Props = {
  children: React.ReactNode;
  isActive: boolean;
  isSelected: boolean;
  isDisabled: boolean;
};

const ListboxOption = forwardRef<TamaguiElement, Props>(
  // rome-ignore lint/correctness/noUnusedVariables: TODO: add support for disabled listbox options
  ({ children, isActive, isSelected, isDisabled, ...restProps }, ref) => {
    return (
      // @ts-ignore - whiteSpace
      <YStack ref={ref} jc="center" tag="li" style={{ whiteSpace: 'nowrap' }}>
        <Text
          fontSize="$12"
          cursor="pointer"
          height="$8"
          display="flex"
          ai="center"
          px="$4"
          backgroundColor={isActive ? '$subtlePale' : '$base'}
          fontWeight={isSelected ? '$medium' : '$regular'}
          numberOfLines={1}
          testID="select-option"
          {...restProps}
        >
          {children}
        </Text>
      </YStack>
    );
  },
);

export default ListboxOption;
